import type { FC } from 'react';

import { Skeleton } from '@/ui/components/skeleton/skeleton';

export const FilterBarSkeleton: FC = () => {
  return (
    <div className="flex flex-row gap-4">
      {/* Simulate SiteFilter placeholder */}
      <div className="flex flex-col gap-1">
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-9 w-52" />
      </div>
      {/* Simulate PCSFilter placeholder */}
      <div className="flex flex-col gap-1">
        {/* Label placeholder */}
        <Skeleton className="h-3 w-12" />
        {/* Dropdown placeholder */}
        <Skeleton className="h-9 w-52" />
      </div>
    </div>
  );
};
